import Button from '../../atoms/button/Button';
import styles from './MinimalFooter.module.scss';
import clsx from 'clsx';
import app from 'frontastic-catwalk/src/js/app/app';
import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch } from 'react-redux';
import { getCurrentLocale } from '../../../utils/getCurrentLocale';

const MinimalFooter = ({
  helpText = null,
  actions = null,
  paymentMethods = null,
  className = null,
  onOpenChat,
}) => {
  const dispatch = useDispatch();
  const currentLocale = getCurrentLocale();

  return (
    <div className={styles.footerWrapper}>
      <div className={clsx(styles.footerMinimalInner, styles[className])}>
        <div className={styles.footerMinimalLinks}>
          {helpText ? (
            <div
              className={styles.helperText}
              dangerouslySetInnerHTML={{ __html: helpText }}
            />
          ) : null}
          {actions &&
            Array.from(actions).map((action, index) => {
              if(currentLocale === action?.actionLocale || action.actionLocale === 'all') {
                if (action.type === 'continue_shopping') {
                  return (
                    <Button
                      key={`continue_shopping_${index}`}
                      variant="primary"
                      shape="square"
                      isOutlined={false}
                      isInverted={false}
                      className={styles.action}
                      onClick={() => app.getRouter().history.nextRouter.back()}
                      as="text"
                    >
                      {action.actionIcon && action.actionIcon.media ? (
                        <svg
                          height={action.actionIcon.media.height}
                          width={18}
                        >
                          <image
                            xlinkHref={action.actionIcon.media.file}
                            src={action.actionIcon.media.file}
                            alt={action.actionIcon.media.name}
                          />
                        </svg>
                      ) : null}
                      {action.actionsTitle && (
                        <span className={styles.actionsTitle}>
                          {action.actionsTitle}
                        </span>
                      )}
                    </Button>
                  );
                }
                if (action.type === 'live_chat') {
                  return (
                    <Button
                      key={`live_chat_${index}`}
                      variant="primary"
                      shape="square"
                      isOutlined={false}
                      isInverted={false}
                      className={styles.action}
                      as="text"
                      onClick={() => {
                        window?.zE && window?.zE('messenger:set', 'zIndex', 99999);
                        onOpenChat();
                      }}
                    >
                      {action.actionIcon && action.actionIcon.media ? (
                        <svg height={18} width={18}>
                          <image
                            xlinkHref={action.actionIcon.media.file}
                            src={action.actionIcon.media.file}
                            alt={action.actionIcon.media.name}
                          />
                        </svg>
                      ) : null}
                      {action.actionsTitle && (
                        <span>{action.actionsTitle}</span>
                      )}
                    </Button>
                  );
                }
                if (action.type === 'faq_popup') {
                  return (
                    <Button
                      key={`faq_popup_${index}`}
                      variant="primary"
                      shape="square"
                      isOutlined={false}
                      isInverted={false}
                      className={styles.action}
                      as="text"
                      onClick={() => {
                        dispatch({
                          type: 'UI.faqPopupToggle',
                          data: true,
                        });
                      }}
                    >
                      {action.actionIcon && action.actionIcon.media ? (
                        <svg height={18} width={18}>
                          <image
                            xlinkHref={action.actionIcon.media.file}
                            src={action.actionIcon.media.file}
                            alt={action.actionIcon.media.name}
                          />
                        </svg>
                      ) : null}
                      {action.actionsTitle && (
                        <span>{action.actionsTitle}</span>
                      )}
                    </Button>
                  );
                }
                if (action.type === 'link') {
                  if (!action || !action.reference || !action.reference.link)
                    return null;
                  return (
                    <a
                      key={`link_${index}`}
                      href={action.reference.link}
                      title={action.actionsTitle}
                      className={styles.action}
                    >
                      {action.actionIcon && action.actionIcon.media ? (
                        <svg height={18} width={18}>
                          <image
                            xlinkHref={action.actionIcon.media.file}
                            src={action.actionIcon.media.file}
                            alt={action.actionIcon.media.name}
                          />
                        </svg>
                      ) : null}
                      {action.actionsTitle && (
                        <span>{action.actionsTitle}</span>
                      )}
                    </a>
                  );
                }
                return null;
              }
              return null;
            })}
        </div>
        <div className={styles.paymentIcons}>
          {paymentMethods &&
            Array.from(paymentMethods).map(({ paymentLocale, paymentIcon }, index) =>
              currentLocale === paymentLocale || paymentLocale === 'all' ? (
                paymentIcon && paymentIcon.media.file ? (
                  <svg
                    key={index}
                    className={paymentIcon.name}
                    height={paymentIcon.media.height}
                    width={paymentIcon.media.width}
                  >
                    <image
                      xlinkHref={paymentIcon.media.file}
                      src={paymentIcon.media.file}
                      alt={paymentIcon.media.name}
                    />
                  </svg>
                ) : null
              ) : null,
            )}
        </div>
      </div>
    </div>
  );
};

MinimalFooter.propTypes = {
  className: PropTypes.string,
  helpText: PropTypes.string,
  actions: PropTypes.array,
  paymentMethods: PropTypes.array,
};

export default MinimalFooter;
